import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { LoginService } from '../services/login.service'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(public ls : LoginService, private router : Router) { 

    
  }

  dashboard_msg = "";

  ngOnInit() {
    this.dashboard_msg = localStorage.getItem('dashboard_msg');
    localStorage.removeItem('dashboard_msg');
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts